module.exports = __webpack_public_path__ + "static/media/malaysian.aa5a089b.png";